<template>
  <div class="tangtang-page min-h-screen pb-[236px] md:min-h-[calc(100vh-64px)] lg:pb-0">
    <div
      class="home mx-auto grid w-[94%] grid-cols-12 gap-4 px-2 py-4 sm:px-4 lg:h-[calc(100svh-80px)] lg:min-h-0 lg:items-stretch lg:py-2"
    >
      <!-- 좌: 전체 채팅 (1) -->
      <div class="hidden h-full min-h-0 lg:col-span-3 lg:block">
        <div class="tangtang-panel flex h-full min-h-0 flex-col">
          <div class="min-h-0 flex-1 overflow-hidden p-2">
            <ChatView class="h-full min-h-0" />
          </div>
        </div>
      </div>
      <!-- 중: 스트리밍 (1) -->
      <div class="col-span-12 h-full min-h-0 lg:col-span-4">
        <div
          class="tangtang-panel flex h-full min-h-[70vh] flex-col p-2 sm:min-h-[78vh] sm:p-3 md:h-[calc(100vh-80px)] lg:h-full lg:min-h-0"
        >
          <div
            class="flex-1 h-full min-h-0 flex items-center justify-center overflow-hidden p-0 relative"
          >
            <div
              v-if="resultProcessing"
              class="absolute left-1/2 top-3 z-10 -translate-x-1/2 rounded-full border border-amber-300/30 bg-[#111a27]/95 px-4 py-2 text-xs font-black text-amber-200 shadow-lg"
            >
              {{ resultProcessing.round }}회차 결과 처리 중
            </div>
            <div v-if="youtubeEmbedUrl" ref="youtubeShell" class="youtube-live-shell">
              <div ref="youtubeFit" class="youtube-live-fit">
                <iframe
                  ref="youtubeFrame"
                  :src="youtubeEmbedUrl"
                  title="YouTube Live"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  allowfullscreen
                  class="youtube-live-frame"
                ></iframe>
              </div>
              <div class="youtube-live-shield" aria-hidden="true"></div>
            </div>
            <div
              v-else
              class="absolute inset-0 flex flex-col items-center justify-center rounded-[28px] border-[10px] border-[#080f1a] bg-black/35 px-6 text-center shadow-[0_0_0_1px_rgba(30,200,255,0.28),0_28px_80px_rgba(0,0,0,0.55)]"
            >
              <strong class="mb-3 text-xl font-black text-[#1ec8ff]">YouTube Live</strong>
              <span class="text-sm font-semibold text-[#9eb6c8]">
                서비스 DB의 youtube_embed_url 설정을 확인해주세요.
              </span>
            </div>
          </div>
        </div>
      </div>
      <!-- 우: 게임 결과 (2) -->
      <div class="col-span-12 h-full min-h-0 lg:col-span-5">
        <div
          class="tangtang-panel flex h-full min-h-[520px] flex-col md:h-[calc(100vh-80px)] lg:h-full lg:min-h-0"
        >
          <!-- 상: 오늘 현황판 (auto height, no scroll) -->
          <div class="p-3 sm:p-4">
            <div class="mb-3 flex flex-col gap-3">
              <div class="flex flex-wrap items-center justify-between gap-2">
                <div class="text-base font-extrabold text-white md:text-lg">
                  탱탱볼 통계 · {{ selectedDateLabel }}
                </div>
                <div class="flex items-center gap-2">
                  <input
                    v-model="selectedStatsDate"
                    type="date"
                    :max="todayDateKey"
                    @change="loadStats"
                    class="rounded-xl border border-white/10 bg-black/30 px-2 py-1.5 text-xs font-bold text-white outline-none focus:ring-2 focus:ring-[#1ec8ff]/40 sm:text-sm"
                  />
                  <button
                    v-if="selectedStatsDate !== todayDateKey"
                    @click="showTodayStats"
                    class="rounded-xl border border-[#1ec8ff]/40 px-3 py-1.5 text-xs font-black text-[#1ec8ff] hover:bg-[#1ec8ff]/10"
                  >
                    오늘
                  </button>
                </div>
              </div>
              <div class="flex flex-wrap gap-2 text-xs font-black sm:text-sm">
                <span class="rounded-full border border-[#1ec8ff]/40 px-3 py-1.5 text-[#1ec8ff]">
                  선택 일자 {{ displayTodayStats.totalCount }}회
                </span>
                <span
                  v-if="displayTodayStats.firstRound"
                  class="rounded-full border border-white/10 px-3 py-1.5 text-slate-300"
                >
                  {{ displayTodayStats.firstRound }} ~ {{ displayTodayStats.lastRound }}회차
                </span>
              </div>
            </div>
            <!-- 0~9 카운트 -->
            <div class="mb-4 grid grid-cols-5 gap-2 sm:grid-cols-10">
              <div v-for="n in 10" :key="n" class="stat-card rounded-2xl p-3 text-center sm:p-2">
                <div class="text-lg font-extrabold text-white sm:text-2xl md:text-3xl">
                  {{ n - 1 }}
                </div>
                <div class="border-t border-white/10 my-2"></div>
                <div class="text-lg font-extrabold text-[#1ec8ff] sm:text-2xl md:text-3xl">
                  {{ displayTodayStats.digitCounts[n - 1] || 0 }}
                </div>
                <div class="mt-1 h-1.5 bg-black/30 rounded">
                  <div
                    class="h-1.5 bg-[#1ec8ff] rounded"
                    :style="{ width: digitPercent(n - 1) + '%' }"
                  ></div>
                </div>
                <div class="mt-1 text-[11px] font-semibold text-[#9eb6c8] sm:text-xs md:text-sm">
                  {{ digitPercent(n - 1) }}%
                </div>
              </div>
            </div>
            <!-- 홀/짝, 언더/오버 합계 -->
            <div class="grid grid-cols-2 gap-3 md:grid-cols-4">
              <div class="stat-card rounded-2xl p-3 text-center">
                <div class="text-xl md:text-2xl font-extrabold text-white">홀</div>
                <div class="border-t border-white/10 my-2"></div>
                <div class="text-2xl md:text-3xl font-extrabold text-sky-400">
                  {{ displayTodayStats.oddCount }}
                  <span class="text-xs md:text-sm font-semibold text-[#9eb6c8] ml-1">
                    ({{ oddPercent }}%)
                  </span>
                </div>
              </div>
              <div class="stat-card rounded-2xl p-3 text-center">
                <div class="text-xl md:text-2xl font-extrabold text-white">짝</div>
                <div class="border-t border-white/10 my-2"></div>
                <div class="text-2xl md:text-3xl font-extrabold text-rose-400">
                  {{ displayTodayStats.evenCount }}
                  <span class="text-xs md:text-sm font-semibold text-[#9eb6c8] ml-1">
                    ({{ evenPercent }}%)
                  </span>
                </div>
              </div>
              <div class="stat-card rounded-2xl p-3 text-center">
                <div class="text-xl md:text-2xl font-extrabold text-white">언더</div>
                <div class="border-t border-white/10 my-2"></div>
                <div class="text-2xl md:text-3xl font-extrabold text-sky-400">
                  {{ displayTodayStats.leftCount }}
                  <span class="text-xs md:text-sm font-semibold text-[#9eb6c8] ml-1">
                    ({{ leftPercent }}%)
                  </span>
                </div>
              </div>
              <div class="stat-card rounded-2xl p-3 text-center">
                <div class="text-xl md:text-2xl font-extrabold text-white">오버</div>
                <div class="border-t border-white/10 my-2"></div>
                <div class="text-2xl md:text-3xl font-extrabold text-rose-400">
                  {{ displayTodayStats.rightCount }}
                  <span class="text-xs md:text-sm font-semibold text-[#9eb6c8] ml-1">
                    ({{ rightPercent }}%)
                  </span>
                </div>
              </div>
            </div>
          </div>
          <!-- 하: 결과 테이블 (fills remaining, scroll here) -->
          <div class="results-scroll relative flex-1 overflow-auto">
            <table class="min-w-[640px] w-full text-center text-xs text-slate-200 sm:min-w-0">
              <thead class="text-xs uppercase bg-[#142235] text-slate-100 sticky top-0 z-10">
                <tr>
                  <th
                    scope="col"
                    class="sticky top-0 z-10 bg-[#142235] px-3 py-4 text-center sm:px-6 sm:py-6"
                  >
                    회차
                  </th>
                  <th
                    scope="col"
                    class="sticky top-0 z-10 bg-[#142235] px-3 py-4 text-center sm:px-6 sm:py-6"
                  >
                    일일회차
                  </th>
                  <th
                    scope="col"
                    class="sticky top-0 z-10 bg-[#142235] px-3 py-4 text-center sm:px-6 sm:py-6"
                  >
                    시간
                  </th>
                  <th
                    scope="col"
                    class="sticky top-0 z-10 bg-[#142235] px-3 py-4 text-center sm:px-6 sm:py-6"
                  >
                    결과
                  </th>
                  <th
                    scope="col"
                    class="sticky top-0 z-10 bg-[#142235] px-3 py-4 text-center sm:px-6 sm:py-6"
                  >
                    홀/짝
                  </th>
                  <th
                    scope="col"
                    class="sticky top-0 z-10 bg-[#142235] px-3 py-4 text-center sm:px-6 sm:py-6"
                  >
                    언더/오버
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="g in selectedDateResults.slice(0, 20)"
                  :key="g.round"
                  class="border-b border-white/10 hover:bg-white/[0.04]"
                >
                  <td
                    scope="row"
                    class="px-3 py-3 font-medium whitespace-nowrap text-center sm:px-6 sm:py-4"
                  >
                    <span class="mr-2">{{ g.round }} 회차</span>
                  </td>
                  <td class="px-3 py-3 text-center font-black text-[#1ec8ff] sm:px-6 sm:py-4">
                    {{ g.dailyRound }}회
                  </td>
                  <td class="px-3 py-3 text-center sm:px-6 sm:py-4">
                    {{ formatKstTime(g.created_at) }}
                  </td>
                  <td class="px-3 py-3 text-center sm:px-6 sm:py-4">{{ g.value }}</td>
                  <td
                    class="px-3 py-3 text-center sm:px-6 sm:py-4"
                    :class="Number(g.value) % 2 === 1 ? 'text-sky-400' : 'text-rose-400'"
                  >
                    {{ Number(g.value) % 2 === 1 ? '홀' : '짝' }}
                  </td>
                  <td
                    class="px-3 py-3 text-center sm:px-6 sm:py-4"
                    :class="Number(g.value) <= 4 ? 'text-sky-400' : 'text-rose-400'"
                  >
                    {{ Number(g.value) <= 4 ? '언더' : '오버' }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <div class="fixed inset-x-0 bottom-0 z-40 lg:hidden">
      <div
        class="rounded-t-[26px] border-x border-t border-white/10 bg-[#111a27]/95 shadow-[0_-12px_40px_rgba(0,0,0,0.42)] backdrop-blur-xl"
      >
        <div class="h-[220px] overflow-hidden">
          <ChatView class="h-full" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import ChatView from './Chat/ChatView.vue';

function buildYoutubeEmbedUrl(value) {
  if (!value) return '';

  try {
    const url = new URL(value);
    const hostname = url.hostname.replace(/^www\./, '').toLowerCase();
    const isYoutubeHost =
      hostname === 'youtube.com' || hostname === 'youtu.be' || hostname === 'youtube-nocookie.com';
    if (!isYoutubeHost) return '';
    const videoId = url.hostname.includes('youtu.be')
      ? url.pathname.replace('/', '')
      : url.searchParams.get('v');

    if (videoId && !url.pathname.includes('/embed/')) {
      url.hostname = 'www.youtube.com';
      url.pathname = `/embed/${videoId}`;
      url.search = '';
    }

    url.searchParams.set('autoplay', url.searchParams.get('autoplay') || '1');
    url.searchParams.set('mute', url.searchParams.get('mute') || '1');
    url.searchParams.set('controls', '0');
    url.searchParams.set('modestbranding', '1');
    url.searchParams.set('disablekb', '1');
    url.searchParams.set('playsinline', '1');
    url.searchParams.set('rel', '0');
    return url.toString();
  } catch (_) {
    return '';
  }
}

function parseGameDate(value) {
  if (!value) return null;
  const text = String(value).trim();
  const hasTimezone = /(?:Z|[+-]\d{2}:\d{2})$/i.test(text);
  const normalized = text.includes('T') ? text : text.replace(' ', 'T');
  const date = new Date(hasTimezone ? normalized : `${normalized}+09:00`);
  return Number.isNaN(date.getTime()) ? null : date;
}

function getKstDateKey(value = new Date()) {
  const date = value instanceof Date ? value : parseGameDate(value);
  if (!date) return '';
  return new Intl.DateTimeFormat('en-CA', {
    timeZone: 'Asia/Seoul',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).format(date);
}

function emptyGameStats() {
  return {
    digitCounts: Array(10).fill(0),
    oddCount: 0,
    evenCount: 0,
    leftCount: 0,
    rightCount: 0,
    totalCount: 0,
    overallTotalCount: 0,
    latestRound: 0,
    firstRound: null,
    lastRound: null,
  };
}

export default {
  components: { ChatView },
  name: 'HomeView',
  async mounted() {
    try {
      const base = process.env.VUE_APP_API_URL || 'http://localhost:3000';
      try {
        const settingsRes = await axios.get(`${base}/settings/public`);
        this.youtubeEmbedUrl = buildYoutubeEmbedUrl(settingsRes.data?.youtubeEmbedUrl);
      } catch (error) {
        console.error('영상 설정 로드 실패', error);
        this.youtubeEmbedUrl = '';
      }
      // 소켓 리스너 등록
      this.$store.commit('onMessage');
      // 선택 일자의 결과와 통계 로드 (DB 기준)
      await this.loadStats();
      this._dateRolloverTimer = window.setInterval(() => this.checkDateRollover(), 1000);
      this._todayRefreshTimer = window.setInterval(() => {
        this.checkDateRollover();
        if (this.selectedStatsDate === this.currentDateKey) {
          this.loadStats({ clear: false });
        }
      }, 10000);
      this._visibilityHandler = () => {
        if (document.visibilityState !== 'visible') return;
        this.checkDateRollover();
        if (this.selectedStatsDate === this.currentDateKey) {
          this.loadStats({ clear: false });
        }
      };
      document.addEventListener('visibilitychange', this._visibilityHandler);
      this.$nextTick(() => this.setupYoutubeFit());
      // 실시간 결과가 들어오면 현황판에 즉시 반영
      if (this.$store.state.socket) {
        // 이전 핸들러 해제 후 등록 (중복 방지)
        if (this._statsHandler) {
          this.$store.state.socket.off('game result', this._statsHandler);
        }
        this._statsHandler = (res) => {
          if (!res || typeof res.value === 'undefined') return;
          this.checkDateRollover();
          if (this.selectedStatsDate !== this.currentDateKey) return;
          // 백엔드가 10초 지연 후 결과를 저장한 시점에 DB 집계를 다시 받아 정확히 동기화한다.
          this.loadStats({ clear: false });
        };
        this.$store.state.socket.on('game result', this._statsHandler);
        this._socketConnectHandler = () => {
          this.checkDateRollover();
          if (this.selectedStatsDate === this.currentDateKey) {
            this.loadStats({ clear: false });
          }
        };
        this.$store.state.socket.on('connect', this._socketConnectHandler);
      }
    } catch (e) {
      console.error('초기 게임 결과 로드 실패', e);
    }
  },
  beforeUnmount() {
    this.teardownYoutubeFit();
    window.clearInterval(this._dateRolloverTimer);
    window.clearInterval(this._todayRefreshTimer);
    document.removeEventListener('visibilitychange', this._visibilityHandler);
    if (this.$store?.state?.socket && this._statsHandler) {
      this.$store.state.socket.off('game result', this._statsHandler);
    }
    if (this.$store?.state?.socket && this._socketConnectHandler) {
      this.$store.state.socket.off('connect', this._socketConnectHandler);
    }
  },
  methods: {
    async loadStats(options = {}) {
      const base = process.env.VUE_APP_API_URL || 'http://localhost:3000';
      const requestedDate = this.selectedStatsDate;
      const requestId = (this._statsRequestId || 0) + 1;
      this._statsRequestId = requestId;
      if (options.clear !== false) {
        this.todayStats = null;
        this.selectedDateResults = [];
      }
      try {
        const [statsResponse, resultsResponse] = await Promise.all([
          axios.get(`${base}/game/stats`, {
            params: { date: requestedDate },
          }),
          axios.get(`${base}/game/results/today`, {
            params: { date: requestedDate, limit: 1000 },
          }),
        ]);
        if (requestedDate !== this.selectedStatsDate || requestId !== this._statsRequestId) return;
        const data = statsResponse.data;
        this.todayStats = {
          digitCounts: data?.digitCounts || Array(10).fill(0),
          oddCount: Number(data?.oddCount || 0),
          evenCount: Number(data?.evenCount || 0),
          leftCount: Number(data?.leftCount || 0),
          rightCount: Number(data?.rightCount || 0),
          totalCount: Number(data?.totalCount || 0),
          overallTotalCount: Number(data?.overallTotalCount || 0),
          latestRound: Number(data?.latestRound || 0),
          firstRound: data?.firstRound == null ? null : Number(data.firstRound),
          lastRound: data?.lastRound == null ? null : Number(data.lastRound),
        };
        this.selectedDateResults = resultsResponse.data?.results || [];
        if (requestedDate === this.todayDateKey) {
          this.$store.commit('mountGame', this.selectedDateResults);
        }
      } catch (error) {
        console.error('일자별 게임 결과/통계 로드 실패', error);
      }
    },
    checkDateRollover() {
      const nextDateKey = getKstDateKey();
      if (!nextDateKey || nextDateKey === this.currentDateKey) return;

      const wasViewingToday = this.selectedStatsDate === this.currentDateKey;
      this.currentDateKey = nextDateKey;
      if (!wasViewingToday) return;

      this.selectedStatsDate = nextDateKey;
      this.todayStats = emptyGameStats();
      this.selectedDateResults = [];
      this.loadStats({ clear: false });
    },
    showTodayStats() {
      this.selectedStatsDate = this.todayDateKey;
      this.loadStats();
    },
    formatKstTime(value) {
      if (!value) return '-';
      const text = String(value).trim();
      const hasTimezone = /(?:Z|[+-]\d{2}:\d{2})$/i.test(text);
      const normalized = text.includes('T') ? text : text.replace(' ', 'T');
      const utcDate = new Date(hasTimezone ? normalized : `${normalized}Z`);
      if (Number.isNaN(utcDate.getTime())) return '-';

      const kstDate = new Date(utcDate.getTime() + 9 * 60 * 60 * 1000);
      const pad = (number) => String(number).padStart(2, '0');
      return [
        pad(kstDate.getUTCHours()),
        pad(kstDate.getUTCMinutes()),
        pad(kstDate.getUTCSeconds()),
      ].join(':');
    },
    setupYoutubeFit() {
      const shell = this.$refs.youtubeShell;
      if (!shell || typeof ResizeObserver === 'undefined') {
        this.fitYoutubeFrame();
        return;
      }
      if (this._youtubeFitObserver) {
        this._youtubeFitObserver.disconnect();
      }
      this._youtubeFitObserver = new ResizeObserver(() => this.fitYoutubeFrame());
      this._youtubeFitObserver.observe(shell);
      this.fitYoutubeFrame();
    },
    teardownYoutubeFit() {
      if (this._youtubeFitObserver) {
        this._youtubeFitObserver.disconnect();
        this._youtubeFitObserver = null;
      }
    },
    fitYoutubeFrame() {
      const shell = this.$refs.youtubeShell;
      const fit = this.$refs.youtubeFit;
      const frame = this.$refs.youtubeFrame;
      if (!shell || !fit || !frame) return;
      const boxW = shell.clientWidth;
      const boxH = shell.clientHeight;
      if (boxW < 2 || boxH < 2) return;
      // 16:9 iframe을 90도 회전하면 9:16이 된다. 그 전체가 셸 안에 들어가게 contain.
      const visW = Math.min(boxW, (boxH * 9) / 16);
      const visH = (visW * 16) / 9;
      fit.style.width = `${visW}px`;
      fit.style.height = `${visH}px`;
      // 레이아웃 박스는 셸 안에 남겨 overflow:hidden에 잘리지 않게 하고,
      // rotate + scale로 회전 후 크기를 맞춘다.
      frame.style.width = `${visW}px`;
      frame.style.height = `${(visW * 9) / 16}px`;
    },
    betting() {
      this.$store.commit('bet');
    },
    percentSafe(numerator, denominator) {
      const d = Number(denominator) || 0;
      if (d <= 0) return 0;
      const v = Math.round((Number(numerator || 0) / d) * 100);
      return isNaN(v) ? 0 : v;
    },
    digitPercent(idx) {
      const counts = this.displayTodayStats.digitCounts || [];
      const total = this.displayTodayStats.totalCount || 0;
      return this.percentSafe(counts[idx] || 0, total);
    },
  },
  computed: {
    gameResults() {
      return this.$store.state.gameResults;
    },
    resultProcessing() {
      return this.$store.state.resultProcessing;
    },
    todayDateKey() {
      return this.currentDateKey;
    },
    selectedDateLabel() {
      const date = parseGameDate(`${this.selectedStatsDate} 00:00:00`);
      if (!date) return this.selectedStatsDate;
      return new Intl.DateTimeFormat('ko-KR', {
        timeZone: 'Asia/Seoul',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
      }).format(date);
    },
    fallbackTodayStats() {
      const list = this.gameResults || [];
      const selectedDateKey = this.selectedStatsDate;
      const digitCounts = Array(10).fill(0);
      let oddCount = 0;
      let evenCount = 0;
      let leftCount = 0;
      let rightCount = 0;
      let totalCount = 0;
      for (const g of list) {
        if (!g?.created_at || getKstDateKey(g.created_at) !== selectedDateKey) continue;
        totalCount++;
        const v = Number(g.value);
        if (!Number.isNaN(v) && v >= 0 && v <= 9) {
          digitCounts[v] += 1;
          if (v % 2 === 1) oddCount += 1;
          else evenCount += 1;
          if (v <= 4) leftCount += 1;
          else rightCount += 1;
        }
      }
      return {
        digitCounts,
        oddCount,
        evenCount,
        leftCount,
        rightCount,
        totalCount,
        overallTotalCount: list.length,
        latestRound: Number(list[0]?.round || 0),
        firstRound: null,
        lastRound: null,
      };
    },
    displayTodayStats() {
      return this.todayStats || this.fallbackTodayStats;
    },
    oddPercent() {
      return this.percentSafe(this.displayTodayStats?.oddCount, this.displayTodayStats?.totalCount);
    },
    evenPercent() {
      return this.percentSafe(
        this.displayTodayStats?.evenCount,
        this.displayTodayStats?.totalCount,
      );
    },
    leftPercent() {
      return this.percentSafe(
        this.displayTodayStats?.leftCount,
        this.displayTodayStats?.totalCount,
      );
    },
    rightPercent() {
      return this.percentSafe(
        this.displayTodayStats?.rightCount,
        this.displayTodayStats?.totalCount,
      );
    },
  },
  data() {
    return {
      betList: [],
      betPrice: 0,
      youtubeEmbedUrl: '',
      todayStats: null,
      currentDateKey: getKstDateKey(),
      selectedStatsDate: getKstDateKey(),
      selectedDateResults: [],
    };
  },
  watch: {
    youtubeEmbedUrl() {
      this.$nextTick(() => this.setupYoutubeFit());
    },
    betList: {
      handler(val) {
        console.log(val);
      },
      deep: true,
    },
  },
};
</script>
<style scoped>
.tangtang-page {
  background:
    radial-gradient(circle at 12% 0%, rgba(30, 200, 255, 0.18), transparent 34rem),
    radial-gradient(circle at 100% 18%, rgba(17, 93, 70, 0.72), transparent 38rem),
    linear-gradient(135deg, #080f1a 0%, #111a27 48%, #10233a 100%);
  color: #f5fff8;
}

.chat-open-button {
  background: #1ec8ff;
  color: #111a27;
}

.tangtang-panel,
.stat-card {
  border: 1px solid rgba(255, 255, 255, 0.1);
  background: rgba(13, 25, 40, 0.86);
  box-shadow: 0 24px 80px rgba(0, 0, 0, 0.35);
  backdrop-filter: blur(18px);
}

.tangtang-panel {
  border-radius: 24px;
  overflow: hidden;
}

.stat-card {
  background: linear-gradient(145deg, rgba(30, 200, 255, 0.13), rgba(12, 33, 51, 0.82)), #111a27;
}

.youtube-live-shell {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  box-sizing: border-box;
  overflow: hidden;
  background: #080f1a;
  box-shadow:
    0 0 0 1px rgba(30, 200, 255, 0.28),
    0 28px 80px rgba(0, 0, 0, 0.55);
}

.youtube-live-fit {
  position: relative;
  flex: 0 0 auto;
  overflow: visible;
  background: #000;
}

.youtube-live-frame {
  position: absolute;
  top: 50%;
  left: 50%;
  border: 0;
  background: #000;
  transform: translate(-50%, -50%) rotate(90deg) scale(1.77777778);
  transform-origin: center;
}

.youtube-live-shield {
  position: absolute;
  inset: 0;
  z-index: 2;
  border-radius: 8px;
  background: transparent;
}

td {
  font-weight: bold;
  font-size: 0.875rem;
}
tr th {
  font-size: 0.875rem;
}
/* 게임 결과 스크롤바 테마 */
.results-scroll::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}
.results-scroll::-webkit-scrollbar-track {
  background: #111a27;
}
.results-scroll::-webkit-scrollbar-thumb {
  background: rgba(30, 200, 255, 0.58);
  border-radius: 999px;
}
.results-scroll::-webkit-scrollbar-thumb:hover {
  background: rgba(30, 200, 255, 0.86);
}
.results-scroll {
  scrollbar-color: rgba(30, 200, 255, 0.58) #111a27;
  scrollbar-width: thin;
}

@media (min-width: 640px) {
  td,
  tr th {
    font-size: 1rem;
  }
}
</style>
